import React, { useState } from "react";
import ReactDOM from "react-dom";
import { IoClose } from "react-icons/io5";
import "./ReportPopup.css";

export default function ReportPopup({ onClose, onSubmit }) {
  const [selectedReason, setSelectedReason] = useState("");
  const [details, setDetails] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedReason) return;
    onSubmit({ reason: selectedReason, details });
    onClose();
  };

  // ⬇️ EVERYTHING below is now wrapped in a portal:
  return ReactDOM.createPortal(
    <div className="report-overlay" onClick={onClose}>
      <div
        className="report-modal"
        onClick={(e) => e.stopPropagation()} // prevents closing when clicking inside
      >
        <button className="report-close" onClick={onClose}>
          <IoClose size={22} />
        </button>

        <div className="report-content">
          <div className="report-emoji">🤔</div>
          <h2 className="report-title">Ops... algo deu errado?</h2>
          <p className="report-desc">
            Nos avise o que há de errado com este cartão. Seu feedback ajuda muito 💚
          </p>

          <form onSubmit={handleSubmit}>
            <div className="report-options">
              <label>
                <input
                  type="radio"
                  name="reason"
                  value="A tradução não faz sentido"
                  checked={selectedReason === "A tradução não faz sentido"}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
                A tradução não faz sentido
              </label>

              <label>
                <input
                  type="radio"
                  name="reason"
                  value="O áudio não corresponde ao texto"
                  checked={selectedReason === "O áudio não corresponde ao texto"}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
                O áudio não corresponde ao texto
              </label>

              <label>
                <input
                  type="radio"
                  name="reason"
                  value="Outro problema"
                  checked={selectedReason === "Outro problema"}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
                Outro problema
              </label>
            </div>

            <textarea
              placeholder="Quer contar mais detalhes? (opcional)"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              className="report-textarea"
            />

            <button
              type="submit"
              className={`report-submit ${!selectedReason ? "disabled" : ""}`}
              disabled={!selectedReason}
            >
              Enviar relatório
            </button>
          </form>
        </div>
      </div>
    </div>,
    document.body // ⬅️ THIS makes the modal appear over everything!
  );
}
